import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { DialogConfig } from './interfaces/dialog-config.interface';

export class DialogRef<Result = undefined> {
  // tslint:disable-next-line: variable-name
  private readonly _afterClosed$ = new Subject<Result>();
  // tslint:disable-next-line: variable-name
  private readonly _visible$ = new BehaviorSubject(true);

  constructor(public readonly config: DialogConfig) {}

  public afterClosed$(): Observable<Result> {
    return this._afterClosed$.asObservable();
  }

  public visible$(): Observable<boolean> {
    return this._visible$.asObservable();
  }

  public close(result?: Result): void {
    this._afterClosed$.next(result);
    this._afterClosed$.complete();
  }

  public hide(): void {
    this._visible$.next(false);
  }

  public show(): void {
    this._visible$.next(true);
  }
}
